import { updatePaginationPage } from '../../../redux/commonSlice';

export const ViewBtns = (props: any) => {
  const { setIsTabular, isTabular, setFilter, className } = props;
  return (
    <div className={`view-btns mr-8 ${className ? className : ''}`}>
      {/* List View Button */}
      <button
        className={isTabular ? 'active' : ''}
        onClick={() => {
          updatePaginationPage(1);
          if (!isTabular) {
            setIsTabular(true);
          }
        }}
      >
        <i className="listing-icon"></i>
      </button>

      {/* Grid View Button */}
      <button
        className={!isTabular ? 'active' : ''}
        onClick={() => {
          updatePaginationPage(1);
          if (setFilter) setFilter();
          if (isTabular) {
            setIsTabular(false);
          }
        }}
      >
        <i className="card-icon"></i>
      </button>
    </div>
  );
};
